module.exports = __webpack_public_path__ + "static/media/time-onclick.b4637a28.svg";